import type { Rng } from '@bm/engine';

/**
 * Zufallsquelle für die lokale Rollenverteilung im Browser.
 *
 * Gegenstück zu `cryptoRng` auf dem Server: `Math.random()` ist vorhersagbar
 * genug, dass ein neugieriger Mitspieler die Verteilung rekonstruieren könnte —
 * und im Ein-Gerät-Modus hat jeder das Gerät kurz in der Hand.
 */
export const browserRng: Rng = () => {
  const buffer = new Uint32Array(1);
  crypto.getRandomValues(buffer);
  return buffer[0]! / 2 ** 32;
};
